import React from 'react';
import { extractGroundingFields } from '../../../utils/intelligenceMeta';
import styles from '../css/index.module.css';

function humanizeWarning(w) {
    return String(w || '')
        .replace(/_/g, ' ')
        .replace(/\b\w/g, ch => ch.toUpperCase());
}

const UnsupportedClaimsBanner = ({ evidenceGovernance, retrievalDebug }) => {
    const { unsupported_claim_count, warnings, hallucination_risk_flag, grounding_status } = extractGroundingFields(
        evidenceGovernance,
        retrievalDebug,
    );

    const count = Number(unsupported_claim_count) || 0;
    const status = String(grounding_status || '').toLowerCase();
    const showRisk = hallucination_risk_flag || status === 'unsupported_claims' || status === 'hallucination_risk';
    const relevantWarnings = (warnings || []).filter(w => /unsupported|hallucin|claim/i.test(String(w)));

    if (count <= 0 && !showRisk && relevantWarnings.length === 0) return null;

    const tone = showRisk ? styles.aiWardenTrustStripDanger : styles.aiWardenTrustStripWarning;

    return (
        <div className={`${styles.aiWardenTrustStrip} ${tone}`} role="alert">
            {count > 0 && (
                <span className={styles.aiWardenTrustStripLabel}>
                    {count} unsupported claim{count === 1 ? '' : 's'} in answer
                </span>
            )}
            {showRisk && count <= 0 && <span className={styles.aiWardenTrustStripLabel}>Elevated narrative integrity risk</span>}
            {relevantWarnings.map(w => (
                <span key={w} className={styles.aiWardenTrustStripMeta}>
                    {humanizeWarning(w)}
                </span>
            ))}
        </div>
    );
};

export default UnsupportedClaimsBanner;
